import EmptySearchImage from "@/assets/images/empty-search.svg?react";
import { EmptyContainer, EmptyText } from "@/components/styling/empty";
import { MDSButton, MDSIcon, MDSButtonSlotName, MDSIconKind } from "@/mds";
import { observer } from "mobx-react-lite";

interface SearchPageNotesListEmptyProps {
  query: string;
  isSuccess: boolean;
  anyFiltersSelected: boolean;
  onRetryClick: () => void;
  onClearFiltersClick?: () => void;
}

export const SearchPageNotesListEmpty = observer(
  ({
    query,
    isSuccess,
    anyFiltersSelected,
    onRetryClick,
    onClearFiltersClick,
  }: SearchPageNotesListEmptyProps): JSX.Element => (
    <EmptyContainer>
      <EmptySearchImage />
      <EmptyText>{getEmptyText(query, isSuccess, anyFiltersSelected)}</EmptyText>
      {!isSuccess && (
        <MDSButton onClick={onRetryClick}>
          <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.Redo} />
          Retry
        </MDSButton>
      )}
      {anyFiltersSelected && isSuccess && onClearFiltersClick && (
        <MDSButton onClick={onClearFiltersClick}>Clear filters</MDSButton>
      )}
    </EmptyContainer>
  )
);

const getEmptyText = (query: string, isSuccess: boolean, anyFiltersSelected: boolean): string => {
  if (!isSuccess) {
    return getErrorText(query);
  }

  if (anyFiltersSelected) {
    return "No results match your selected filters";
  }

  if (query) {
    return "No results for " + `"${query}"`;
  }

  return "No results match your search";
};

const getErrorText = (query: string): string => {
  if (query) {
    return "Could not load results for " + `"${query}"`;
  }

  return "Could not load results";
};
